import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-azul-lago py-4">
      <div className="container mx-auto px-4 text-center">
        <p className="text-sm text-blanco">© 2024 DRIZA. Todos los derechos reservados.</p>
       
      </div>
    </footer>
  );
};

export default Footer;